import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { OffCanvas, OffCanvasMenu, OffCanvasBody } from "react-offcanvas";

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../../components/frontend/auth/AuthUtility';
import LoadingSpinner from '../../components/frontend/LoadingSpinner';
import Copyright from './Copyright';
import { LogoutService } from '../../components/utils/LogoutService';
import { useOffCanvas } from '../../context/OffCanvasProvider';
import DonatePanel from '../../components/panels//DonatePanel';

import swal from 'sweetalert';

import close_icon from '../../assets/frontend/images/close_icon_black.png';

const OffCanvasNav = () => {

	const { push: openCanvas } = useOffCanvas();  // load offcanvas functions

	//logout should be its own component
	const navHistory = useNavigate();

	// using hooks
	const [isLoading, setIsLoading] = useState(false);
	const [isNavOpen, setIsNavOpen] = useState(false);
	const [isHomeOpen, setIsHomeOpen] = useState(false);
	const [isDashboardOpen, setIsDashboardOpen] = useState(false);
	const [isUserProfileSettingsOpen, setIsUserProfileSettingsOpen] = useState(false);

	//check if clicked target is not within the offcanvasnav
	const mobileIconRef = useRef();
	const navRef = useRef();
	const closeNavRef = useRef();

	useEffect(() => {
		const handleClickOutside = (event) => {

			// add event listener to close menu when clicked outside		
			if (navRef.current && !navRef.current.contains(event.target)) {
				setIsNavOpen(false);
			}

			//open nav with mobile icon click which is in the div id=navigation
			if (!isNavOpen && mobileIconRef.current && mobileIconRef.current.contains(event.target) && mobileIconRef.current.id === 'mobile_icon') {
				setIsNavOpen(true);
			}
		}

		//get and set nav and menu states
		if (localStorage.getItem('auth_role')) {
			if (localStorage.getItem('is_home_open') && (localStorage.getItem('is_home_open') === true || localStorage.getItem('is_home_open') === 'true')) {
				setIsHomeOpen(true);
			} else {
				localStorage.setItem('is_home_open', false);
				setIsHomeOpen(false);
			}
			if (localStorage.getItem('is_dashboard_open') && (localStorage.getItem('is_dashboard_open') === true || localStorage.getItem('is_dashboard_open') === 'true')) {
				setIsDashboardOpen(true);
			} else {
				localStorage.setItem('is_dashboard_open', false);
				setIsDashboardOpen(false);
			}
			if (localStorage.getItem('is_user_profile_settings_open') && (localStorage.getItem('is_user_profile_settings_open') === true || localStorage.getItem('is_user_profile_settings_open') === 'true')) {
				setIsUserProfileSettingsOpen(true);
			} else {
				localStorage.setItem('is_user_profile_settings_open', false);
				setIsUserProfileSettingsOpen(false);
			}
		}

		document.addEventListener("mousedown", handleClickOutside)

		return () => {
			// Cleanup the event listener
			document.removeEventListener("mousedown", handleClickOutside)
		}
	}, [isNavOpen]);

	const toggleNav = (event) => {
		event.preventDefault();

		if (localStorage.getItem('auth_role')) {
			console.log('is_home_open: ' + localStorage.getItem('is_home_open'));
			console.log('is_dashboard_open: ' + localStorage.getItem('is_dashboard_open'));
			console.log('is_user_profile_settings_open: ' + localStorage.getItem('is_user_profile_settings_open'));

			//get and set nav and menu states
			if (localStorage.getItem('is_home_open') && (localStorage.getItem('is_home_open') === true || localStorage.getItem('is_home_open') === 'true')) {
				setIsHomeOpen(true);
			} else {
				localStorage.setItem('is_home_open', false);
				setIsHomeOpen(false);
			}
			if (localStorage.getItem('is_dashboard_open') && (localStorage.getItem('is_dashboard_open') === true || localStorage.getItem('is_dashboard_open') === 'true')) {
				setIsDashboardOpen(true);
			} else {
				localStorage.setItem('is_dashboard_open', false);
				setIsDashboardOpen(false);
			}
			if (localStorage.getItem('is_user_profile_settings_open') && (localStorage.getItem('is_user_profile_settings_open') === true || localStorage.getItem('is_user_profile_settings_open') === 'true')) {
				setIsUserProfileSettingsOpen(true);
			} else {
				localStorage.setItem('is_user_profile_settings_open', false);
				setIsUserProfileSettingsOpen(false);
			}
		}

		setIsNavOpen(!isNavOpen);
	}

	const toggleMenuItem = (event) => {
		event.stopPropagation();

		if (localStorage.getItem('auth_role')) {
			if (event.target.id === 'home') {
				localStorage.setItem('is_home_open', !isHomeOpen);
				setIsHomeOpen(!isHomeOpen);
			} else if (event.target.id === 'dashboard') {
				localStorage.setItem('is_dashboard_open', !isDashboardOpen);
				setIsDashboardOpen(!isDashboardOpen);
			} else if (event.target.id === 'user_profile_settings') {
				localStorage.setItem('is_user_profile_settings_open', !isUserProfileSettingsOpen);
				setIsUserProfileSettingsOpen(!isUserProfileSettingsOpen);
			}
		}
	};

	const handleMenuLinkItemClick = (event) => {
		event.stopPropagation();

		// close menu when submenu link item is clicked
		setIsNavOpen(false);

		// get the "to" attribute value from the clicked link
		const toAttribute = event.currentTarget.getAttribute('to');
		console.log('toAttribute: ' + toAttribute);
		// get the "href"" value from the clicked link
		const hrefValue = event.currentTarget.attributes.href.value;
		console.log('hrefValue: ' + hrefValue);

		if (toAttribute) {
			// navigate to the next view using the dynamically obtained "to" value
			navHistory(toAttribute);
		} else if (hrefValue) {
			// navigate to the next view using the dynamically obtained "to" value
			navHistory(hrefValue);
		} else {
			// handle the case when "to" attribute is not present
			console.error('Error: "to" attribute not found on the clicked link');
		}
	};

	var AllRoleLinks = '';
	var RoleDashboardLink = '';
	var RoleAccountLink = '';
	var RoleSettingsLink = '';
	var RoleFeatureLinks = '';

	var RoleFeatureLinks = '';
	var PublicLinks = '';

	var submenuLinkPadding = (
		<span className="pl-25"></span>
	);

	// member or admin
	if (AuthUtility.isLoggedIn()) {

		if (localStorage.getItem('auth_role') === 'member') {
			RoleDashboardLink = '/member/account';
			RoleAccountLink = '/member/profile';
			RoleSettingsLink = '/member/settings';

			RoleFeatureLinks = (
				<ul className="menu-mobile-nav pt-5">
					<li className={isDashboardOpen ? 'submenu-active' : ''}><Link id="dashboard" className="uppercase" onClick={toggleMenuItem} onTouchEnd={toggleMenuItem}>Dashboard</Link>
						<ul className="submenu-mobile-nav">
							<li><Link to="/member/videos" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Videos</Link></li>
							<li><Link to="/member/payments" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Payments</Link></li>
						</ul>
					</li>
				</ul>
			);
		} else if (localStorage.getItem('auth_role') === 'admin') {
			RoleDashboardLink = '/admin/account';
			RoleAccountLink = '/admin/profile';
			RoleSettingsLink = '/admin/settings';

			RoleFeatureLinks = (
				<ul className="menu-mobile-nav pt-5">
					<li className={isDashboardOpen ? 'submenu-active' : ''}><Link id="dashboard" className="uppercase" onClick={toggleMenuItem} onTouchEnd={toggleMenuItem}>Dashboard</Link>
						<ul className="submenu-mobile-nav">
							<li><Link to="/admin/plans" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Plans</Link></li>
							<li><Link to="/admin/users" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Users</Link></li>
							<li><Link to="/admin/subscriptions" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Subscriptions</Link></li>
						</ul>
					</li>
				</ul>
			);
		}

		AllRoleLinks = (
			<ul className="menu-mobile-nav">
				<li className={isUserProfileSettingsOpen ? 'submenu-active' : ''}><Link id="user_profile_settings" className="uppercase" onClick={toggleMenuItem} onTouchEnd={toggleMenuItem}>{localStorage.getItem('auth_name')}</Link>
					<ul className="submenu-mobile-nav">
						<li><Link to={RoleAccountLink} className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Account</Link></li>
						<li><Link to={RoleSettingsLink} className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Settings</Link></li>
						<li><Link className="uppercase" onClick={() => LogoutService({ setIsLoading, navHistory, swal })} onTouchEnd={() => LogoutService({ setIsLoading, navHistory, swal })}>{submenuLinkPadding}Logout</Link></li>
					</ul>
				</li>
			</ul>
		);

		PublicLinks = (
			<ul className="menu-mobile-nav pt-5">
				<li className={isHomeOpen ? 'submenu-active' : ''}><Link id="home" className="uppercase" onClick={toggleMenuItem} onTouchEnd={toggleMenuItem}>Website</Link>
					<ul className="submenu-mobile-nav">
						<li><Link to="/" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Home</Link></li>
						<li><Link to="/search" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Search</Link></li>
						<li><Link to="/about" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}About</Link></li>
						<li><Link to="/contact" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Contact</Link></li>
						<li><Link to="/events" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Events</Link></li>
						<li><Link to="/help" className="uppercase" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>{submenuLinkPadding}Help</Link></li>
					</ul>
				</li>
			</ul>
		);
	} else {
		PublicLinks = (
			<ul className="menu-mobile-nav guest">
				<li><Link className="" onClick={(e) => openDonate(e)}>Donate</Link></li>
				<li><Link to="/radios" className="" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>Radio</Link></li>
				<li><Link to="/podcasts" className="" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>Podcasts</Link></li>
				<li><Link to="/home" className="" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>Home</Link></li>

				<li><Link to="/about" className="" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>About</Link></li>
				<li><Link to="/contact" className="" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>Contact</Link></li>
				<li><Link to="/events" className="" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>Events</Link></li>
				<li><Link to="/help" className="" onClick={handleMenuLinkItemClick} onTouchEnd={handleMenuLinkItemClick}>Help</Link></li>
			</ul>
		);
	}

	function openDonate(e) {
		e.stopPropagation();

		openCanvas({
			component: DonatePanel,
			props: {
				track: null,
				tracklist: null,
			}
		});
	}

	function handleComingSoon(text) {

		swal("Info", text + " Coming Soon.", "info");
	}

	return (
		<OffCanvas width={200} transitionDuration={300} effect={"parallax"} isMenuOpened={isNavOpen} position={"right"}>
			<OffCanvasBody>
				<div id="mobile_icon" className="horizontal-container float-right" ref={mobileIconRef}>
					<button className="button mobile-icon right" type="button" onClick={toggleNav} onTouchEnd={toggleNav}>
						<div className="hamburger-mobile-nav">
							<span className="bar"></span>
							<span className="bar"></span>
							<span className="bar"></span>
						</div>
					</button>
				</div>
			</OffCanvasBody>
			<OffCanvasMenu>
				<div id="mobile_nav" className="bg-fafafa bl1-ccc" ref={navRef}>

					<div className="panel">
						<div className="grid-x p-10">
							<div className="large-10 medium-10 small-9 cell text-center">
								{isLoading &&
									<span className="element"><LoadingSpinner paddingclassName="none" sizeclassName="small" /></span>
								}
							</div>
							<div className="large-2 medium-2 small-3 cell text-right">
								<Link to="#" className="button icon text-center" onClick={toggleNav} onTouchEnd={toggleNav} ref={closeNavRef}>
									<img src={close_icon} className="" width="40" alt="add new check list" />
								</Link>
							</div>
						</div>
					</div>

					<div className="plr-10 pb-10">
						{AllRoleLinks}
						{RoleFeatureLinks}
						{PublicLinks}
					</div>
					<Copyright />
				</div>
			</OffCanvasMenu>
		</OffCanvas>
	);

}

export default OffCanvasNav;